import React,{useEffect} from "react";
import 'react-awesome-slider/dist/styles.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScreenResize from "../ScreenResize/ScreenResize";
import normatecaStore from "../../../stores/normatecaStore";



export default function SitiosAfines(){
    const imgurl = process.env.REACT_APP_IMG_URL + "normateca/secciones/sitiosafines/"; 
    const screen= ScreenResize();

    const {setSitiosAfines,jsonSitiosAfines} =
    normatecaStore((state) =>( { 
        setSitiosAfines: state.setSitiosAfines,
        jsonSitiosAfines: state.jsonSitiosAfines,
     })); 
     useEffect(() => {
        setSitiosAfines().catch(null);
      }, []);
      const ArrowBack = ({ className, style, onClick }) => (
        <button style={{...style, display: "block",width: "auto",height: "auto",marginTop: "-2rem",
            marginLeft: "-2rem", left: 0}} onClick={onClick} className={className}>
          <div>back</div>
        </button>
      );
      const ArrowNext = ({ className, style, onClick }) => (
        <button style={{...style, right: 0, display: "block",width: "auto",height: "auto",marginTop: "-2rem",
        marginRight:"-4rem"}} onClick={onClick} className={className}>
          <div>back</div>
        </button>
      );
      const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        autoplaySpeed:7000,
        slidesToShow: screen.width<500? 1 : screen.width < 1000? 3: screen.width < 1260? 4 : 4,
        slidesToScroll: screen.width<500 ? 1 : screen.width < 1000? 3: screen.width < 1260? 4 : 4,
        autoplay: true,
        prevArrow: <ArrowBack />,
        nextArrow: <ArrowNext />
      }
      
    return(
        <div>
            <div className="divTit">
                <div className="titpublicRes">Sitios relacionados</div>
                <div className="linepublicRes"></div>
            </div>
            <div className="divSitAfin">
                <div className="divDeIntSha">
                    <div className="divCarruselDI">
                        <Slider {...settings}  >
                        {jsonSitiosAfines?.map((ia,index)=>(
                                <div key={"ja" + index.toString()} >
                                    <div className="zoom padRight-05">
                                        <a href={ia.url} target="_blank" className="cursor-pointer">
                                            <img src={imgurl + ia.img} />
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
            {/* <Row className="divSitAfin" >
                {jsonSitiosAfines?.map((ai,index)=>(
                        <Col sm={1} key={"ja" + index.toString()} className="zoom alignSelf-center width-auto">
                            <a href={ai.url} target="_blank"><img src={imgurl + ai.img} /></a>
                        </Col>
                    ))}
            </Row>
             */}
             <div className="divSitAfin2" >
                {jsonSitiosAfines?.map((ai,index)=>(
                        <div key={"saf" + index.toString()} className="padBottom-05">
                            <a href={ai.url} target="_blank">{ai.descripcion}</a>
                        </div>
                    ))}
            </div>
        </div>
    )
}